/* External */
import { useEffect } from 'react';

/* Ott-common */
import { Errors } from '@dtvgo/player-utils';

/* Utils */
import parentalControlBlock from '~/utils/parentalControlUtils';

export default function useParentalControlError(content, {
  onError, playbackStarted, readyToPlay,
}) {
  useEffect(() => {
    if (parentalControlBlock(content) && readyToPlay) {
      const parentalControlError = Errors.getParentalControlError(
        content?.rating,
        JSON.parse(localStorage.getItem('profile'))?.ageRating,
        JSON.parse(localStorage.getItem('profile'))?.name,
      );
      parentalControlError.data.playbackStarted = playbackStarted?.();
      onError(parentalControlError);
    }
  }, [content, onError, playbackStarted, readyToPlay]);
}
